import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import '../OfficesPage.scss'
import PagesControl from '../../../components/library/pages/PagesControl';


const EmployeesQueueTablePages = ({ queue, onSetOffset }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [lastPage, setLastPage] = useState(-1)

    useEffect(() => {
        var o = Number(queue.offset);
        var totalCount = Number(queue.count);
        var limit = Number(queue.limit);

        if (o >= 0 && totalCount > 0 && limit > 0) {
            setCurrentPage(Math.floor(o / limit));
            setLastPage(Math.ceil(totalCount / limit) - 1)
        }
    }, [queue.offset, queue.count, queue.limit])

    const handleSetPage = (page) => {
        if (page !== currentPage) {
            onSetOffset(page * queue.limit)
        }
    }

    return (
        <div className="columns">
            <div className='column is-12'>
                <div className='page-ctrl'>
                    <PagesControl currentPage={currentPage} maxPage={lastPage} onSetPage={handleSetPage} />
                </div>
            </div>
        </div>
    );
}

EmployeesQueueTablePages.propTypes = {
    queue: PropTypes.object.isRequired,
    onSetOffset: PropTypes.func.isRequired
}

export default EmployeesQueueTablePages